import posthog from 'posthog-js';
import { useCallback, useEffect, useState } from 'react';

import { useNavigator } from '../hooks/useNavigator';
import { useStore } from '../hooks/useStore';
import useTranslation from '../hooks/useTranslation';

import SelectedDevice from '../components/SelectedDevice';
import ContactForm from '../components/ContactForm';
import Alert from '../components/icons/Alert';
import StepTemplate from '../components/StepTemplate';
import { SpinnerButton } from '@/lib/components/ui/spinnerButton';
import { Button } from '@/lib/components/ui/button';

const ContactStep = () => {
  const translations = useTranslation();
  const navigateBack = useNavigator((state) => state.navigateBack);
  const navigateForward = useNavigator((state) => state.navigateForward);

  const registerTradeIn = useStore((state) => state.registerTradeIn);
  const setDetails = useStore((state) => state.setDetails);
  const setMarketingConsent = useStore((state) => state.setMarketingConsent);
  const postingTradeIn = useStore((state) => state.postingTradeIn);
  const [registerError, setRegisterError] = useState(false);

  const onSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      console.log('ContactStep onSubmit');
      event.preventDefault();
      const formData = new FormData(event.currentTarget as HTMLFormElement);

      const { marketingConsent, ...details } = Object.fromEntries(formData);

      setMarketingConsent(marketingConsent === 'on');
      setDetails(details);

      if (await registerTradeIn()) {
        navigateForward();
      } else {
        setRegisterError(true);
      }
    },
    [setDetails, registerTradeIn],
  );

  useEffect(() => {
    posthog.capture('Open Contact Details Step');
  }, []);

  return (
    <form onSubmit={onSubmit}>
      <StepTemplate
        title={translations.contactFormTitle}
        subTitle={translations.contactFormSubTitle}
        step={3}
        footer={
          <div className="flex space-x-4">
            <Button
              variant={'outline'}
              type="button"
              onClick={navigateBack}
              aria-label={translations['back']}
            >
              {translations['back']}
            </Button>
            <SpinnerButton
              type="submit"
              loading={postingTradeIn}
              aria-label={translations['send']}
            >
              {translations['send']}
            </SpinnerButton>
          </div>
        }
      >
        <div className={'bg-white p-4 sm:px-10 sm:py-7 rounded-lg'}>
          <ContactForm />
          <SelectedDevice />
        </div>

        {registerError && (
          <p className="flex items-center text-sm text-destructive pt-1">
            <Alert className="w-5 h-5 sm:w-3 sm:h-3 mr-1" />{' '}
            {translations['errorTradeIn']}
          </p>
        )}
      </StepTemplate>
    </form>
  );
};

export default ContactStep;
